module.exports = function rgb2hex(color) {
	return "#" + ((1 << 24) + (color.R << 16) + (color.G << 8) + color.B).toString(16).slice(1);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/closest-color/src/rgb2hex.js
// module id = 203
// module chunks = 0